import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-modal w-maxC" }
const _hoisted_2 = { class: "row w-full" }
const _hoisted_3 = { class: "addressInputGrid mtop-15" }
const _hoisted_4 = { class: "address-form-item" }
const _hoisted_5 = { class: "main-m font-m" }
const _hoisted_6 = { class: "gcol-r mtop-035" }
const _hoisted_7 = { class: "address-form-item" }
const _hoisted_8 = { class: "gcol-r" }
const _hoisted_9 = { class: "address-form-item" }
const _hoisted_10 = { class: "gcol-r" }
const _hoisted_11 = { class: "pad-m rnd-m bg-h" }
const _hoisted_12 = { class: "address-form-item" }
const _hoisted_13 = { class: "gcol-r" }
const _hoisted_14 = { class: "address-form-item" }
const _hoisted_15 = { class: "gcol-r" }
const _hoisted_16 = { class: "bg-modal w-maxC dropd-scroll" }
const _hoisted_17 = { class: "mtop-10 address-form-item" }
const _hoisted_18 = { class: "gcol-r" }

import { COUNTRY_LIST, getFlagEmojiForCountry } from '@/functions/geo.js';

import { ref, computed, type PropType, onMounted } from 'vue';
import { useUiStore } from '@/stores/ui';
import { AddressPersonRequest, AddressRequest, InstituteAddress } from '@/apiGenerate/medserver';
import { useI18n } from 'vue-i18n';
import ToggleSwitch from "primevue/toggleswitch";

type OwnerType = 'patient' | 'healthGroup' | 'institute'


export default /*@__PURE__*/_defineComponent({
  __name: 'addressInput',
  props: {
  address: {
    type: Object,
    required: false,
  },
  pwr: {
    type: Object,
    required: false,
  },
  iwr: {
    type: Object,
    required: false,
  },
  ownerType: {
    type: String as PropType<OwnerType>,
    required: true,
  },
  isUpdate: {
    type: Boolean,
    required: false,
    default: false
  },
  canDelete: {
    type: Boolean,
    required: false,
    default: true
  }
},
  emits: ['close', 'update-person-address', 'update-institute-address', 'delete-institute-address', 'delete-person-address', 'create-institute-address', 'create-person-address'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const uiStore = useUiStore();

const props = __props;

const emits = __emit;
const focusRef = ref(null);
const dropd = ref("");

const isInstitute = computed(() => props.ownerType === 'institute');

const showPreferred = computed(() => {
  if (props.ownerType === 'patient') {
    return uiStore.adminDashBoardView === 'dashbPatient';
  }
  if (props.ownerType === 'institute') {
    return true;
  }
  return false;
})

const showNote = computed(() => !isInstitute.value);

const isPreferredAddress = ref<boolean>(props.address?.isPreferred);

const streetInput = ref(props.address?.street || '');

async function updateAddress() {  
  if (isInstitute.value) {
    const addressRequest: AddressRequest = {
      country: currentIsoCountry.value,
      locality: localityInput.value,
      postalCode: postalCodeInput.value,
      street: streetInput.value
    }
    emits('update-institute-address', addressRequest);
  } else {
    const addressPersonRequest: AddressPersonRequest = {
        address: {
          country: currentIsoCountry.value,
          locality: localityInput.value,
          postalCode: postalCodeInput.value,
          street: streetInput.value,
        },
        note: noteInput.value,
        isFavorite: isPreferredAddress.value
    }
    emits('update-person-address', addressPersonRequest);
  }
}

const postalCodeInput = ref(props.address?.postalCode || '')

const localityInput = ref(props.address?.locality || '')

const currentCountry = ref(props.address?.country || COUNTRY_LIST[0].term)
const currentIsoCountry = ref(props.address?.isoCountry || COUNTRY_LIST[0].isoCode)

function setCountry(country) {
  currentCountry.value = country.term
  currentIsoCountry.value = country.isoCode
  dropd.value = ""
}

const noteInput = ref(props.address?.note || '')

async function deleteAddress() {
  if (!props.address) return;
  emits('close')
  if (isInstitute.value) {
    emits('delete-institute-address');
  } else {
    emits('delete-person-address');
  }
}

async function addAddress() {
  if (props.address) return;
  emits('close');

  if (isInstitute.value) {
    const instituteAddress: InstituteAddress = {
      address: {
        street: streetInput.value, 
        postalCode: postalCodeInput.value, 
        locality: localityInput.value, 
        isoCode: currentIsoCountry.value
      }
    }

    emits('create-institute-address', instituteAddress);
  } else {
    const personAddress: AddressPersonRequest = {
      address: {
        street: streetInput.value, 
        postalCode: postalCodeInput.value, 
        locality: localityInput.value, 
        country: currentIsoCountry.value
      },
      note: noteInput.value
    }

    emits('create-person-address', personAddress);
  }
}

const closeFormModal = () => {
  if (props.isUpdate) {
    updateAddress();
  } else {
    addAddress();
  }
}

onMounted(() => {
  focusRef.value.innerRef.focus()
})

return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_es_modal_header, {
        header: _unref(t)('common.contactForm.title.address'),
        "display-delete": !!props.address && __props.canDelete,
        "label-delete": _unref(t)('action.delete'),
        "confirm-method": deleteAddress
      }, null, 8, ["header", "display-delete", "label-delete"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (props.address && showPreferred.value && !isInstitute.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('common.contactForm.label.address.isDefault')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(ToggleSwitch), {
                modelValue: isPreferredAddress.value,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((isPreferredAddress).value = $event)),
                  _cache[1] || (_cache[1] = ($event: any) => (isPreferredAddress.value = $event))
                ]
              }, null, 8, ["modelValue"])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_text_item, {
          txt: "Rue",
          styles: "main-m"
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              ref_key: "focusRef",
              ref: focusRef,
              modelValue: streetInput.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((streetInput).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_text_item, {
          txt: "Code",
          styles: "main-m"
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_inputBox, { class: "row-stretch" }, {
          default: _withCtx(() => [
            (props.address?.postalCodePrefix)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_text_item, {
                      txt: props.address?.postalCodePrefix || '',
                      styles: "main-m",
                      style: {"margin":"0 0.4rem"}
                    }, null, 8, ["txt"])
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "line-v" })
                  ], -1))
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_inputLineNew2, {
              modelValue: postalCodeInput.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((postalCodeInput).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_text_item, {
          txt: "Ville",
          styles: "main-m"
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              modelValue: localityInput.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localityInput).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_text_item, {
          txt: "Pays",
          styles: "main-m"
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dropd).value = $event)),
          openOn: "editAddressCountry"
        }, {
          dropd: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COUNTRY_LIST), (country, index) => {
                return (_openBlock(), _createBlock(_component_list_group, {
                  key: index,
                  styles: "pad-s",
                  onClick: ($event: any) => (setCountry(country))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(getFlagEmojiForCountry)(country.isoCode)
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: country.term,
                      class: "mleft-08"
                    }, null, 8, ["txt"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_inputBox, null, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, { class: "w-full row" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(getFlagEmojiForCountry)(currentIsoCountry.value),
                      class: "mleft-02"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: currentCountry.value,
                      class: "mleft-04"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row w-full mtop-10" }, null, -1)),
      (showNote.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_text_item, {
                txt: "Note",
                styles: "main-m"
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_inputBox, null, {
                default: _withCtx(() => [
                  _createVNode(_component_inputAreaAuto2, {
                    modelValue: noteInput.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((noteInput).value = $event)),
                    lines: 3
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ], 64))
        : _createCommentVNode("", true),
      _cache[10] || (_cache[10] = _createElementVNode("div", null, null, -1))
    ]),
    _createVNode(_component_es_modal_footer, {
      onModalCancel: _cache[7] || (_cache[7] = ($event: any) => (emits('close'))),
      "confirm-modal-method": closeFormModal,
      class: "mtop-12"
    })
  ]))
}
}

})